// extracted by mini-css-extract-plugin
export default {"header":"Album_header__YUTgY","cover":"Album_cover__hGv12","names":"Album_names__gpaCn"};